import { RightOutlineIcon } from '@carboncopyco/icons';
import {
  SectionTitle,
  type SectionTitleProps,
} from '../../../TransactionRuleModal';

export interface StepButtonProps
  extends Pick<SectionTitleProps, 'title' | 'iconType'> {
  onClick: () => void;
}

export const StepButton = ({ title, iconType, onClick }: StepButtonProps) => {
  return (
    <div
      className="py-5 hover:bg-ds-natural-50 group cursor-pointer"
      onClick={onClick}
    >
      <div className="h-9 px-5 flex flex-col justify-center">
        <div className="flex justify-between">
          <SectionTitle
            title={title}
            iconType={iconType}
          />
          <div className="flex gap-1.5 group-hover:visible invisible text-ds-natural-600 font-medium text-sm">
            Edit
            <RightOutlineIcon size={20} />
          </div>
        </div>
      </div>
    </div>
  );
};
